import '/components/image-carousel/image-carousel';
